<template>
    <div class="meeting-empty__wrapper">
        <h1 class="meeting-empty__title">Você ainda não recebeu propostas de reunião</h1>
        <p class="meeting-empty__description">Fique atento a sua caixa de entrada. Caso receba, entre aqui para aceitar os convites</p>
        <img class="meeting_empty__img" src="@/assets/images/pages/meeting/blank_meeting.svg" alt="Image de reunião vazia">
    </div>
</template>

<script>
export default {
    name: 'meeting-empty-card'
}
</script>

<style lang="scss">
@import '@/assets/scss/talent/components/meetingemptycard.scss';
</style>